export default {
    apiUrl: process.env.REACT_APP_API_URI,
    host: `${window.location.origin}`
};
